export const maleOnlyTag = 'male-only'
export const femaleOnlyTag = 'female-only'

// Public nodes stating who the user is rather than something measured about
// them, so rules about a measurement (optimal state, timeframe) don't apply.
export const PROFILE_NODE_NAMES: readonly string[] = ['Sex', 'Age']
